// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow___MHAl","amount":"Amount_amount__Z0eha","tip":"Amount_tip__1MFnM","tipHeader":"Amount_tipHeader__3XAiI","tipsWrap":"Amount_tipsWrap__2G66J"};